import axios from 'axios'
import { pick } from 'lodash'
import vueCookie from 'vue-cookie'
import store from '@/store'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_END_POINT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use((request) => {
  let session
  try {
    session = JSON.parse(vueCookie.get('session')) || []
  } catch (e) {
    session = []
  }
  if ('access-token' in session && 'client' in session && 'uid' in session) {
    request.headers['access-token'] = session['access-token']
    request.headers['client'] = session['client']
    request.headers['uid'] = session['uid']
  }
  request.timeout = 30000
  store.dispatch('httpRequest')
  return request
}, (error) => {
  return Promise.reject(error)
})

http.interceptors.response.use((response) => {
  if ('access-token' in response.headers && 'client' in response.headers && 'uid' in response.headers) {
    const authHeaders = pick(
      response.headers,
      [
        'access-token',
        'client',
        'expiry',
        'uid',
        'token-type'
      ]
    )
    const cookieOptions = {
      expires: '14D'
    }
    if (process.env.NODE_ENV !== 'development' && process.env.VUE_APP_HOST) {
      cookieOptions.domain = process.env.VUE_APP_HOST
      cookieOptions.secure = true
    }
    vueCookie.set('session', JSON.stringify(authHeaders), cookieOptions)
  }
  store.dispatch('httpResponse')
  return response
}, (error) => {
  switch (error.response?.status) {
    case 403: {
      store.commit('setForbidden', true)
      break
    }
    case 404: {
      store.commit('setNotFound', true)
      break
    }
    case 500: {
      store.commit('setInternalServerError', true)
      break
    }
  }
  store.dispatch('httpResponse')
  return Promise.reject(error)
})

export default http
